import { functions } from "./firebase";
import env from "@/env";

const getStripeSessionId = functions.httpsCallable("getStripeSessionId");

let stripeJsPromise = null;

function urlForRoute(route) {
  return `${window.location.origin}${route}`;
}

/**
 * Load Stripe.js only when the legacy session redirect path needs it.
 * Prefer checkoutUrl redirects which need no Stripe.js at all.
 */
function loadStripeJs() {
  if (typeof window === "undefined") {
    return Promise.reject(new Error("Stripe requires a browser"));
  }
  if (window.Stripe) {
    return Promise.resolve(window.Stripe);
  }
  if (stripeJsPromise) {
    return stripeJsPromise;
  }

  stripeJsPromise = new Promise((resolve, reject) => {
    const script = document.createElement("script");
    script.src = "https://js.stripe.com/v3/";
    script.async = true;
    script.onload = () => {
      if (window.Stripe) {
        resolve(window.Stripe);
      } else {
        stripeJsPromise = null;
        reject(new Error("Stripe.js loaded but Stripe is unavailable"));
      }
    };
    script.onerror = () => {
      stripeJsPromise = null;
      reject(new Error("Failed to load Stripe.js"));
    };
    document.head.appendChild(script);
  });

  return stripeJsPromise;
}

export async function checkoutBooking({ bookingId, shopId, stripeCustomerId }) {
  const response = await getStripeSessionId({
    // eslint-disable-next-line @typescript-eslint/camelcase
    booking_id: bookingId,
    sessionOpts: {
      // eslint-disable-next-line @typescript-eslint/camelcase
      success_url: urlForRoute(`/booking-confirmation/${bookingId}`),
      // eslint-disable-next-line @typescript-eslint/camelcase
      cancel_url: urlForRoute(
        `/shops/${shopId}?checkout_cancelled=true&bid=${bookingId}`
      )
    }
  });

  const sessionId = response.data;
  const StripeCtor = await loadStripeJs();
  const stripe = StripeCtor(env.stripe.key, {
    stripeAccount: stripeCustomerId
  });

  stripe.redirectToCheckout({ sessionId });
}
